const cryptBytes = (dataBytes, keyStr) => {
  const key = new Uint8Array(32);
  let h = 5381;
  for (let i = 0; i < keyStr.length; i++) h = ((h << 5) + h + keyStr.charCodeAt(i)) >>> 0;
  for (let i = 0; i < 32; i++) {
    h = ((h << 5) + h + i) >>> 0;
    key[i] = h & 0xff;
  }
  const out = new Uint8Array(dataBytes.length);
  for (let i = 0; i < dataBytes.length; i++) {
    const k = key[i % 32];
    let x = dataBytes[i];
    x = ((x << 3) | (x >>> 5)) & 0xff;
    x = x ^ k;
    out[i] = x;
  }
  return out;
};

const bytesToStr = b => new TextDecoder().decode(b);
// 旧版 Safari（如 iOS 13）Uint8Array.from 可能抛 TypedArray 兼容错误，改为手动填充
const base64ToBytes = s => {
  const bin = atob(s);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    bytes[i] = bin.charCodeAt(i);
  }
  return bytes;
};

export const decrypt = (base64Cipher, keyStr) => {
  return bytesToStr(cryptBytes(base64ToBytes(base64Cipher), keyStr));
};
